import React, { Component } from "react";
//container pages
import Government from "../content/Government";
import FormUnavailable from "./formUnavailablePage";
//importing API calls functions
//import Connector from './utils/api/Connector';

import Wait from "@react/react-spectrum/Wait";
import AppErrorPage from "../../components/errors/AppErrorPage";
import {
  isUnprocessableEntityError,
  normalizeApiErrorMessages,
} from "../../components/errors";

class GovernmentPage extends Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.props.connector.searchEmail(
      this.onSearchComplete,
      this.props.formName,
    );
  }

  onSearchComplete = (data) => {
    this.setState({ data: data, isLoading: false });
  };

  errorCodes = ["40301", "41008"];

  render() {
    return (
      <div>
        {this.state.isLoading ? (
          <Wait size="L" centered />
        ) : this.state.data.isError ? (
          isUnprocessableEntityError(this.state.data) ? (
            <AppErrorPage
              title="Unable to load this page"
              errorPayload={this.state.data}
              messages={normalizeApiErrorMessages(this.state.data)}
            />
          ) : this.errorCodes.includes(this.state.data.errorCode) ||
            this.state.data.message === "Unauthorized access" ? (
            <FormUnavailable
              searchData={this.state.data}
              formName={this.props.formName}
            />
          ) : (
            <AppErrorPage
              title="Unable to load this page"
              errorPayload={this.state.data}
              messages={normalizeApiErrorMessages(this.state.data)}
            />
          )
        ) : this.state.data.contactInfo.mainContactType === "Primary" &&
          this.state.data.specializationInfo &&
          this.state.data.specializationInfo.government ? (
          <Government data={this.state.data} {...this.props} />
        ) : (
          <FormUnavailable
            searchData={this.state.data}
            formName={this.props.formName}
          />
        )}
      </div>
    );
  }
}

export default GovernmentPage;
